import React from 'react';
import { trackContactClick } from '../../utils/analytics';

/**
 * WhatsAppButton - Global floating WhatsApp CTA.
 * Rendered at the router level so it persists across every page/route.
 * 
 * Features:
 * - Fixed bottom-right positioning
 * - Subtle idle pulse animation to draw attention
 * - Hover glow + scale effect
 * - Tooltip on hover ("Chat with us")
 * - z-index 50 - above content, below modals (z-9999)
 */
const WhatsAppButton = () => (
  <a
    href="https://wa.me/971524818924"
    target="_blank"
    rel="noreferrer"
    aria-label="Chat with us on WhatsApp"
    onClick={() => trackContactClick('whatsapp', 'floating_button')}
    className="fixed bottom-6 right-6 sm:bottom-8 sm:right-8 z-50 group"
  >
    {/* Tooltip */}
    <span
      className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap
        rounded-lg bg-gray-900 px-3 py-1.5 text-sm font-medium text-white
        opacity-0 pointer-events-none transition-opacity duration-200
        group-hover:opacity-100 shadow-lg"
      aria-hidden="true"
    >
      Chat with us
    </span>

    <div className="relative">
      {/* Idle pulse ring */}
      <span className="absolute inset-0 rounded-full bg-green-500/30 animate-wa-pulse" />

      {/* Hover glow */}
      <span className="absolute inset-0 bg-green-500 rounded-full blur-md opacity-0 group-hover:opacity-40 transition-opacity duration-300" />

      <img
        src="/assets/logos/WA-logo.svg"
        width={58}
        height={58}
        alt="WhatsApp"
        className="relative z-10 transition-transform duration-300 group-hover:scale-110 drop-shadow-lg"
        loading="lazy"
        decoding="async"
      />
    </div>
  </a>
);

export default WhatsAppButton;
